import React from 'react';
import { message } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import Detail from './components/Detailed/Detail';
import { postFrom, config, transterQuery } from '../../axios';
import { liuShuiMeiJu, dicPayChannel, dicPayType } from '../../axios/dictionaries'
import moment from 'moment';
import axios from 'axios';
import {moneyAddComma, handleExportParams, isPlatform} from '../../utils/index'

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: {
                buildingName: '',
                checkTimeEnd: '',
                checkTimeStart: '',
                createTimeEnd: '',
                createTimeStart: '',
                customerName: '',
                receiveOrPay: 1,
                keyword: '',
                pageSize: 10,
                payChannel: '',
                payType: '',
                phone: '',
                projectName: '',
                roomNo: '',
                shortName: '',
                status: 3,
                tradeTimeEnd: '',
                tradeTimeStart: '',
            }, //搜索参数
            current: 1, //当前页
            tableData: [], //表格数据
            tableTotalMny: 0,
            tableDiscountTotalMny: 0,
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showDetailModal: false, //显示详情
            inputSearchTerm: "170px", //查询条件宽度
        }
    }

    componentDidMount() {
        this.handleSearch();
    }


    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};
        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        axios.all([
            postFrom({ url: config.API_traderecord_findPage, data }),
            postFrom({ url: config.API_traderecord_getTotalMoney, data }),
            postFrom({ url: config.API_traderecord_getDiscountTotalMoney, data }),
        ]).then(axios.spread((listRes, CountRes,CountDiscountRes) => {

            if(!isPlatform()){
                CountDiscountRes=0;
            }
            this.setState({ current: listRes.current, tableTotal: listRes.total, tableTotalMny: CountRes,tableDiscountTotalMny:CountDiscountRes, tableData: listRes.records, tableLoading: false })
        })).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        })
    }

    handleShowDetail = (id) => { //显示详情
        this.setState({ showDetailModal: true });
        this.detailRef.loadPackage(id);
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showDetailModal,
            inputSearchTerm,
            tableTotalMny,
            tableDiscountTotalMny,
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper search-wrapper-two" style={{ flexDirection: 'column', }}>
                    <SuperForm
                        data={searchData(inputSearchTerm)}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                    <div className="search-btn-list template-style">
                        <AuthButton authkey="f-1-3" type="primary" icon="export" href={`${config.API_traderecord_tradeRecordExprot}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                            导出
                        </AuthButton>
                    </div>
                </div>

                <TableDOM
                    columns={columns({ current, handleShowDetail: this.handleShowDetail })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    totalMny={tableTotalMny}
                    totalDiscountMny={tableDiscountTotalMny}
                    current={current}
                    onChange={this.handleSearch}
                />
                <Detail
                    onRef={ref => this.detailRef = ref}
                    visible={showDetailModal}
                    handleCancel={() => { this.setState({ showDetailModal: false }) }}
                />
            </PageWrap>
        )
    }


}

const searchData = (inputSearchTerm) => {
    let data = [
        {
            tagName: 'Input',
            formConfig: { name: 'shortName' },
            attribute: { placeholder: '输入商户简称', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'projectName' },
            attribute: { placeholder: '输入项目', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'buildingName' },
            attribute: { placeholder: '输入小区/楼栋', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'roomNo' },
            attribute: { placeholder: '输入房号', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'tradeTimeStart' },
            attribute: { placeholder: '请选择交易开始日期', style: { width: inputSearchTerm } },
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'tradeTimeEnd' },
            attribute: { placeholder: '请选择交易结束日期', style: { width: inputSearchTerm } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'orderNoThird' },
            attribute: { placeholder: '输入他方流水', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Select',
            formConfig: { name: 'payChannel' },
            attribute: { placeholder: '请选择交易渠道', style: { width: inputSearchTerm } },
            optionData: [{ title: '全部', value: '' }].concat(dicPayChannel), //.concat(dicHouseStatus)
            notResult: '',
        },
        {
            tagName: 'Select',
            formConfig: { name: 'payType' },
            attribute: { placeholder: '请选择交易方式', style: { width: inputSearchTerm } },
            optionData: [{ title: '全部', value: '' }].concat(dicPayType), //.concat(dicHouseStatus)
            notResult: '',
        },
        {
            tagName: 'Input',
            formConfig: { name: 'customerName' },
            attribute: { placeholder: '输入租客', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'phone' },
            attribute: { placeholder: '输入手机号码', style: { width: inputSearchTerm } }
        },
        // {
        //     tagName: 'Select',
        //     formConfig: { name: 'status' },
        //     attribute: { placeholder: '请选择交易状态', style: { width: inputSearchTerm } },
        //     optionData: [{ title: '全部', value: '' }].concat(liuShuiMeiJu), //.concat(dicHouseStatus)
        //     notResult: '',
        // },
    ]
    handleExportParams().merchantId ? data.splice(0, 1) : '';
    return data;
};
const columns = ({ current, handleShowDetail }) => {
    let column=[
    {
        title: '交易时间',
        dataIndex: 'tradeTime',

        render(text, record, index) {
            return <span>
                <div>{record.tradeTime ? moment(record.tradeTime).format('YYYY-MM-DD HH:mm') : ""}</div>
            </span>
        }
    },
    {
        title: '我方流水 | 他方流水',
        dataIndex: 'orderNo',

        render(text, record, index) {
            return <span>
                <div>{record.orderNo ? record.orderNo : null}</div>
                {
                    record.orderNoThird
                        ? <React.Fragment>
                            <div>{record.orderNoThird ? record.orderNoThird : null}</div>
                        </React.Fragment>
                        : null
                }
            </span>
        }
    },
    {
        title: '交易金额 | 名称',
        dataIndex: 'amount',
        // align: 'right',
        render(text, record, index) {
            return <span>
                <div>{record.amount ? moneyAddComma(record.amount) : null}</div>
                <div>{record.feeName}</div>
            </span>
        }
    },
    {
        title: '优惠金额',
        dataIndex: 'discountAmount',
        // align: 'right',
        render(text, record, index) {
            return <span>
                <div>{moneyAddComma(record.discountAmount)}</div>
            </span>
        }
    },
    {
        title: '交易渠道 | 方式',
        dataIndex: 'payChannels',

        render(text, record, index) {
            let now = dicPayChannel.find(item => item.value === record.payChannel);
            let nows = dicPayType.find(item => item.value === record.payType);
            if (now) {
                return <span>
                    <div>{now ? now.title : null}</div>
                    <div>{nows ? nows.title : null}</div>
                </span>
            }
            return null
        }
    },
    {
      title: '平台商户分账金额',
      dataIndex: 'platformAmount',
    },
    {
      title: '子商户分账金额',
      dataIndex: 'subAmount',
    },
    {
      title: '房号',
      dataIndex: 'roomNos'
    },
    {
        title: '租客',
        dataIndex: 'customerName',

        render(text, record, index) {
            return <span>
                <div>{record.customerName}</div>
                <div>{record.customerPhone}</div>
            </span>
        }
    },
    {
        title: '交易状态',
        dataIndex: 'status',

        render(text, record, index) {
            let now = liuShuiMeiJu.find(item => item.value === text);
            if (now)
                return <span style={{color:now.color}}>
                    <div >{now.title}</div>
                </span>
            return null
        }
    },
    {
        title: '商户 | 项目',
        dataIndex: 'mustPadyDate',

        render(text, record, index) {
            return <span>
                <div>{record.merchantName}</div>
                <div>{record.projectName}</div>
            </span>
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        render(text, record, index) {
            return (<div>
                <AuthButton authkey="f-1-2"><span className="showClickDetail" onClick={() => { handleShowDetail(record.tradeRecordId) }}>详情</span></AuthButton>
                {/* <Divider type="vertical" />
                    <Popconfirm placement="top" title={"确定删除吗？"} onConfirm={() => { handleDelete(record.id) }} okText="确定" cancelText="不了">
                        <span className="showClickDetail">删除</span>
                    </Popconfirm> */}
            </div>)
        }
    }

]

    column = column.filter(e => {
        if(isPlatform()){
            return true;
        }
        if (e.dataIndex === 'discountAmount') {
            return false;
        }

        return true;
    });

    return column;



};



// WEBPACK FOOTER //
// ./src/page/Payment/Detailed.js